"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var colors = {
  debug: '#939393',
  success: '#00bb2d',
  info: '#3694ff',
  warn: '#ffa500',
  error: '#b20000'
};
var formatLog = function formatLog(level, message, data, moduleName) {
  var suffix = moduleName || 'Generic';

  /* eslint no-console: "off" */
  return console.log("%c Systems SDK | ".concat(suffix, " %c ").concat(message, " %c"), 'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff', "background:".concat(colors[level], " ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff"), 'background:transparent', data);
};
var _default = exports["default"] = {
  success: function success(message, data, suffix) {
    formatLog('success', message, data, suffix);
  },
  info: function info(message, data, suffix) {
    formatLog('info', message, data, suffix);
  },
  warn: function warn(message, data, suffix) {
    formatLog('warn', message, data, suffix);
  },
  error: function error(message, data, suffix) {
    formatLog('error', message, data, suffix);
  },
  debug: function debug(message, data, suffix) {
    formatLog('debug', message, data, suffix);
  }
};